import styled from 'styled-components';

const Wrapper = styled.section`
  .main {
    height: 450px !important; /* Adjusted height */
    width: 450px !important; /* Adjusted width */
    position: relative;
    z-index: 2;
    rounded:full;
  }

  .magnify-container {
    z-index: 2; /* Higher z-index to ensure the magnified image appears above the accordion */
  }
  
  img {
    max-width: 100000px !important;
    width: 100%;
    display: block;
    border-radius: var(--radius);
    object-fit: cover;
  }
  .gallery {
    margin-top: 1rem;
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    column-gap: 1rem;
    width: 100%;
    img {
      height: 100px;
      cursor: pointer;
    }
  }
  .active {
    box-shadow: 0px 0px 0px 2px var(--clr-primary-5);
  }
  @media (max-width: 576px) {
    .main {
      height: auto !important;
      width: 100% !important;
      img {
        height: auto !important;
        width: 100% !important;
      }
    }
    .gallery {
      img {
        height: 70px;
      }
    }
  }
  @media (min-width: 992px) {
    .main {
      min-height: 550px !important;
      width: 450px !important;
      height:auto;
      max-height:1200px;
    }
    .gallery {
      img {
        height: 100px;
      }
    }
  }
`;

export default Wrapper;
